export default "__VITE_ASSET__k9l9Bb5LQ1cIcbBEU6U7rQ__"